import script from "./NbsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NbsMenu.vue?vue&type=script&setup=true&lang=js"

import "./NbsMenu.vue?vue&type=style&index=0&id=03088e98&lang=scss"

const __exports__ = script;

export default __exports__